import { EventInfo } from '@calendar';
import OREventType from '@data/openCalendar/OREventType';

const filterHandledEvents = (e: EventInfo) => Object.keys(OREventType).includes(e.type);

export default filterHandledEvents;
